<template>
    <!-- «Піца-рулетка»: скибки з іменами, піца крутиться ≈4 с і зупиняється скибкою під стрілкою -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'idle'">Крутіть піцу — на кого вкаже стрілка, той платить</template>
            <template v-else-if="state == 'spin'">Крутиться…</template>
            <template v-else>Стрілка на <b>{{ players[target] }}</b>!</template>
        </p>
        <div class="bp-wp-wheel">
            <span class="bp-wp-wheel__arrow" aria-hidden="true"></span>
            <svg viewBox="0 0 300 300" class="bp-wp-wheel__svg" :style="{ transform: 'rotate(' + rot + 'deg)' }" @transitionend="stop" aria-hidden="true">
                <g v-for="slice in slices" :key="slice.i">
                    <path :d="slice.d" :fill="slice.fill" stroke="#fff" stroke-width="2"/>
                    <text :transform="slice.tf" class="bp-wp-wheel__name" text-anchor="end" dominant-baseline="middle">{{ slice.name }}</text>
                </g>
                <circle cx="150" cy="150" r="143" fill="none" stroke="#d9a15a" stroke-width="10"/>
                <circle cx="150" cy="150" r="32" fill="#fff" stroke="#e3ded6" stroke-width="2"/>
                <image :href="logo" x="126" y="124" width="48" height="52"/>
            </svg>
        </div>
        <button type="button" class="bp-wp-btn bp-wp-btn--main" :disabled="state != 'idle'" @click="spin()">Крутити</button>
    </div>
</template>

<script>
// Скибки по черзі: тісто, томат, сир; при непарній кількості остання — третім кольором, щоб сусіди не злипались
const FILLS = ['#f6e3c4', '#f3c1b9', '#fbeee0'];

export default {
    name: 'GameWheel',
    props: {
        players: { type: Array, required: true }
    },
    data() {
        return {
            rot: 0,
            target: 0,
            state: 'idle',
            logo: require('@/assets/logo_site_mob.webp')
        }
    },
    computed: {
        slices() {
            const n = this.players.length, step = 360 / n, r = 140, c = 150;
            const p = deg => { const a = (deg - 90) * Math.PI / 180; return [(c + r * Math.cos(a)).toFixed(2), (c + r * Math.sin(a)).toFixed(2)]; };
            return this.players.map((name, i) => {
                const [x0, y0] = p(i * step), [x1, y1] = p((i + 1) * step), mid = i * step + step / 2;
                const fill = n % 2 && i == n - 1 ? FILLS[2] : FILLS[i % 2];
                return {
                    i, fill,
                    d: `M${c} ${c}L${x0} ${y0}A${r} ${r} 0 ${step > 180 ? 1 : 0} 1 ${x1} ${y1}Z`,
                    // Ім'я вздовж радіуса, від краю до центру
                    tf: `rotate(${mid - 90} ${c} ${c}) translate(${c + 124} ${c})`,
                    name: name.length > 12 ? name.slice(0, 11) + '…' : name
                };
            });
        }
    },
    methods: {
        spin() {
            const n = this.players.length, step = 360 / n;
            this.target = Math.floor(Math.random() * n);
            const centre = this.target * step + step / 2 + (Math.random() - .5) * step * .7;
            // Обертаємо за годинниковою: скибка з кутом centre має стати під стрілку (0°)
            const now = ((this.rot % 360) + 360) % 360;
            const need = ((360 - centre - now) % 360 + 360) % 360;
            this.state = 'spin';
            this.rot += 360 * 5 + need;
        },
        stop() {
            if (this.state != 'spin') return;
            this.state = 'done';
            setTimeout(() => this.$emit('done', { loser: this.target, note: 'Так вирішила піца-рулетка' }), 900);
        }
    }
}
</script>
